<template>
  <div class="dj-schedule-page content">
    <div class="main-content-area">
      <section class="schedule-header text-center">
        <HeadImage :image="mainImg" align="text-center"
                   :color="secondaryColor"
                   :clamp="true" title="DJ SCHEDULE"
                   caption="Tulum, Mexico"></HeadImage>
      </section>

      <div class="page-content">
        <p class="schedule-intro-text">
          <strong>Tulum</strong> is one of the biggest clusters of
          <strong>DJs and Artists</strong>
          in all of the continent. Few places truly square up to Tulum in terms of its exclusivity and range of prolific high-profile DJs and Producers showing up in town
          <router-link :to="{ path: '/tulum-party-mexico-event-calendar' }">week by week</router-link>.
        </p>
        <p class="text-center" style="font-weight: bold;font-size: 1rem">tulum.party</p>
        <p class="text-center " style="font-size: 0.5rem;margin-top: -6px">PLAN A | SIDE B</p>

      </div>

      <hr class="section-divider">

      <div class="highlight-section card">
        <h3 class="dj-schedule-section-title text-center">Highlights</h3>
        <HotThisWeek align="text-center" :secondary-color="secondaryColor" />
      </div>
      <hr class="section-divider">

      <section class="card" >
        <h3 class="section-header">
          <img v-lazy="fire" height="50px" width="50px" style="border: 1px solid orange;border-radius: 500px" alt="Trending Icon">
          What's Trending?</h3>
        <div class="brands-grid">
          <div
            v-for="event in djSchedule.filter(x => x.metadata.highlight)"
            :key="event.slug"
            class="brand-card"
          >
            <router-link :to="{ path: event.metadata.event_link }" class="card-link">
              <div class="card-image-container">
                <ResponsiveImage :image="event.metadata.image_url" :alt="event.title" class="brand-image"/>
                <div class="card-image-overlay">
                  <h2 class="upcoming-artist-event-section">{{ event.title }}</h2>
                  <p class="brand-legend">{{  niceDate(event) }}</p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </section>

      <section class="highlight-section" >
        <h3 class="section-header">
          <img v-lazy="fire" height="50px" width="50px" style="border: 1px solid orange;border-radius: 500px" alt="Schedule Icon">
          SCHEDULE </h3>
        <img v-lazy="djImage" class="pull-right" height="200px" alt="DJ mixing">


        <div class="form-group form-control">
          <div
            class="input-group input-group-lg"
            :class=" 'active-input' "
            style="
                    background-color: #1a1818;
                      max-width: 300px;
                      margin-left: auto;
                      margin-right: auto;
                      left: 0;
                      right: 0;
                      padding: 30px;
                      margin-top: 2px;
                    "
          >
            <input
              type="text"
              class="form-control"
              aria-describedby="sizing-addon1"
              name="search"
              autocomplete="false"
              v-model.lazy="searchTerm"
              placeholder="Search by artist or event..."
            />
          </div>
        </div>
      </section>

      <section class="full-schedule-section">
        <div
          v-for="(eventsInDate, date) in periodDates"
          :key="date"
          class="date-group"
        >
          <div class="date-header">
            <span class="weekday"> · {{ getDayOfWeek(date + 'T00:00') }}</span>
            <span class="month">{{ getMonthShort(date + 'T00:00') }}</span>
            <span class="day">{{ getDayNumeric(date + 'T00:00') }}</span>
          </div>

          <div class="events-for-date">
            <div v-for="event in eventsInDate" :key="event.slug + event.title" class="event-entry">
              <ArtistCard
                :image="event.metadata && event.metadata.image_url"
                :show-content="true"
                :event="event"
                class="standard-artist-card"
              />

              <p class="badge-pill" v-if="showFilter">{{event.metadata.genre}}</p>
            </div>
          </div>
        </div>
        <div v-if="Object.keys(periodDates).length === 0 && !$store.state.status.loading" class="no-events">
          <p>No upcoming DJ events found for your search. Check back soon!</p>
        </div>
      </section>

      <div class="total-events-footer text-center">
        <small>Total Upcoming: {{ djSchedule.length }}</small>
      </div>

      <section class="section-divider"></section>

      <section class="highlight-section" >
        <div class="card">
          <h3 class="section-header">Featured Tulum Playlist:</h3>
          <SpotifyPlaylist
            listId="7oO7WANISfRNvACyuFoR6Z"
            image="https://imgix.cosmicjs.com/9ee6efd0-3bf0-11f0-bb16-a9798b4099b1-Tulum_DJ_Schedule__Who_s_Playing_When___Where.png"
            playlistName="Tulum 2025"
            loadPromptText="Tap to load the sounds of Tulum"
            width="100%"
            height="380px"
          />
        </div>
        <strong>tulum.party</strong>
      </section>
      <hr class="section-divider">
      <section >
        <h3 class="section-header">Production Brands</h3>
        <BrandCollection class="brand-collection-bottom" />
      </section>
    </div>

    <aside class="sidebar-area card d-none d-lg-block">
      <SmartMenu
        :links="links"
        :logo="astroImg"
        ctaText="INFO"
        top-section-name="GET IN TOUCH"
        :primary-color="primaryColor"
      >
        <div class="sidebar-cta-text">
          <p>
            <strong>Do you need any recommendation</strong> based on your musical taste?
            <br />
            Drop us a line <br />we'll make you dance.
          </p>
          <hr />
        </div>
      </SmartMenu>
      <section>
        <h3 class="section-header">Production Brands</h3>
        <BrandCollection />
      </section>

    </aside>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BrandCollection from '@/components/Cards/BrandCollection';
import SmartMenu from '@/components/SmartMenu/SmartMenu';
import HotThisWeek from '@/pages/DjSchedule/HotThisWeek';
import { eventDateMixin } from '@/common/eventDateMixin';
import ArtistCard from '@/components/Cards/ArtistCard';
import HeadImage from '@/components/HeadImage/HeadImage';
import {eventScheduleSchemaGenerator} from '@/common/EventScheduleSchemaGenerator';
import SpotifyPlaylist from '@/components/Spotify/SpotifyPlaylist';
import ResponsiveImage from '@/components/HeadImage/ResponsiveImage';

export default {
  name: 'DjSchedule',
  mixins: [eventDateMixin],
  components: {
    ResponsiveImage,
    SpotifyPlaylist,
    HeadImage,
    ArtistCard,
    HotThisWeek,
    BrandCollection,
    SmartMenu,
  },
  data: () => {
    return {
      mainImg: "https://imgix.cosmicjs.com/b00d8380-5c9a-11f0-b63e-ad8e919a7a99-dj-calendar-tulum.jpg",
      searchTerm: '',
      selectedGenres: [],
      primaryColor: '#1C1C1F',
      showFilter: false,
      fire: 'https://imgix.cosmicjs.com/15cd3df0-02af-11f0-9c94-c1d9b01cc071-e7b0917d2772c83bd52a9d011624c536.webp',
      secondaryColor: 'rgb(255, 141, 114)',
      astroImg: 'https://imgix.cosmicjs.com/1098dee0-e8ea-11ef-b333-e101bec29f3d-atro-transparent.png',
      djImage: 'https://imgix.cosmicjs.com/9f39a6a0-c70a-11ee-9ce5-59949019255e-dj.png',
    };
  },
  metaInfo() {
    const ldJsonScript = {
      type: 'application/ld+json',
      json: this.scheduleSchema
    };
    const scripts = this.scheduleSchema ? [ldJsonScript] : [];

    return {
      title: `Tulum DJ Schedule: Who's Playing When & Where`,
      script: scripts,
      __dangerouslyDisableSanitizers: ['script'],
      meta: [
        { name: 'description', content: `Don't miss a beat! See the hottest DJs spinning in Tulum this week. Our Tulum DJ schedule shows you who's playing, when, and where.` },
        { name: 'keywords', content: `Tulum dj schedule, events, calendar, clubs, party agenda, dj agenda` },
        { property: 'og:title', content: `Don't Miss Out! Upcoming Tulum DJ Events` },
        { property: 'og:url', content: `https://www.tulum.party/tulum-dj-schedule` },
        { property: 'og:description', content: `Don't miss a beat! See the hottest DJs spinning in Tulum this week. Our Tulum DJ schedule shows you who's playing, when, and where.` },
        { property: 'og:type', content: 'website' }
      ]
    };
  },
  computed: {
    ...mapState({
      djScheduleFromStore: state => state.djSchedule,
      links: state => state.links || [],
    }),
    genreOptions() {
      const genres = new Set();
      this.djSchedule.forEach(event => {
        // It reads the `event.metadata.genre` property as requested.
        const genreTag = event.metadata.genre;
        if (genreTag) {
          console.log(genreTag);
          genreTag.split(/\||,|and|&/i).forEach(g => genres.add(g.trim().toUpperCase()));
        }
      });
      return Array.from(genres).sort();
    },
    djSchedule() {
      // This computed property is now just for initial sorting and filtering of past events
      return [...this.djScheduleFromStore]
        .filter(event => event && event.metadata && this.isIncomingParty('day', event))
        .sort((a, b) => {
          const dateA = new Date(`${a.metadata.date}T${a.metadata.start_time || '00:00'}`);
          const dateB = new Date(`${b.metadata.date}T${b.metadata.start_time || '00:00'}`);
          return dateA - dateB;
        });
    },
    // ✅ This computed property handles all filtering logic.
    filteredDjSchedule() {
      let schedule = this.djSchedule;

      // 1. Filter by search term
      if (this.searchTerm) {
        const query = this.searchTerm.toLowerCase();
        schedule = schedule.filter(event =>
          (event.title && event.title.toLowerCase().match(query)) ||
          (event.slug && event.slug.toLowerCase().match(query)) ||
          (event.metadata && event.metadata.genre && event.metadata.genre.toLowerCase().match(query))

        );
      }


      return schedule;
    },
    scheduleSchema() {
      return eventScheduleSchemaGenerator(this.djSchedule)
    },
    // ✅ UPDATED: This now depends on the filtered list
    periodDates() {
      let _periodDates = {};
      this.filteredDjSchedule.forEach((event) => {
        if (event && event.metadata && event.metadata.date) {
          const dateKey = event.metadata.date;
          if (_periodDates[dateKey]) {
            _periodDates[dateKey].push(event);
          } else {
            _periodDates[dateKey] = [event];
          }
        }
      });
      return _periodDates;
    }
  },
  mounted() {
    this.$store.dispatch('getDjSchedule');
    this.$store.dispatch('getLinks', { slug: 'tulum-dj-schedule' });
    this.$meta().refresh();
  },
  methods: {
    // This method is now a native JS implementation, removing the moment.js dependency
    isIncomingParty(unitOfTime, x) {
      if (!x.metadata.date) return false;
      const eventDate = new Date(`${x.metadata.date}T00:00:00Z`); // Treat date as UTC
      const now = new Date();
      const today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
      return eventDate.getTime() >= today.getTime();
    },

  }
};
</script>
